interface MomentumChipProps {
  label: string | null | undefined;
}

// Tiny eyebrow-tracked label — color follows the verb.
const RULES: Array<{ test: RegExp; color: string }> = [
  { test: /stalled|stale|0d|—/i, color: "#cf6679" },
  { test: /race|deadline|critical/i, color: "#cf6679" },
  { test: /accelerat|high/i, color: "#7ec699" },
  { test: /ready|shipped|done/i, color: "#7ec699" },
  { test: /low|easy/i, color: "#6ba6c9" },
  { test: /medium|drafting/i, color: "#d4a04c" },
];

function colorFor(label: string): string {
  for (const r of RULES) if (r.test.test(label)) return r.color;
  return "var(--plum)";
}

export default function MomentumChip({ label }: MomentumChipProps) {
  if (!label)
    return (
      <span style={{ color: "var(--plum)", opacity: 0.5, fontSize: 11 }}>—</span>
    );
  const color = colorFor(label);
  return (
    <span
      className="font-eyebrow inline-flex items-center"
      style={{
        color,
        fontSize: 9,
        fontWeight: 800,
        letterSpacing: "0.1em",
        textTransform: "uppercase",
      }}
    >
      {label}
    </span>
  );
}
